export default __webpack_public_path__ + "static/media/selected1.ce661780.png";